import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { AreaChartWebElement } from './AreaChartWebElement';
export { AreaChartWebElement };

/**
 * Retrieve an instance of [AreaChartWebElement](../classes/AreaChartWebElement.html).
 * @example
 * ```javascript
 * import { findAreaChart } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findAreaChart(driver, By.id('my-oj-c-area-chart'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findAreaChart(driver: DriverLike, by: By): Promise<AreaChartWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type AreaChartWebElement
  if (!(webEl instanceof AreaChartWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'AreaChartWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findAreaChart(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${AreaChartWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-area-chart', AreaChartWebElement);
